export enum ResponseType {
  Blob = 'blob'
}
